import { combineReducers } from 'redux';

import { reducer as listReducer } from './listModule';
import { reducer as detailsReducer } from './detailsModule';
import { reducer as remove } from './removeModule';

export default combineReducers({
	details: detailsReducer,
	remove,
	list: listReducer,
});
